import React from 'react';
import AntdCustomButton from '../buttons/AntdCustomButton';
import { BodyText } from '../ui/Typography';
import { useTranslation } from 'react-i18next';

interface ActionButtonsProps {
  onSave?: () => void;
  onCancel?: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ onSave, onCancel }) => {
  const { t } = useTranslation();
  return (
    <div className="action-buttons">
      <AntdCustomButton
        appearance="important"
        className="save-button mr-[18px]"
        onClick={onSave}
      >
        {t('Save page structure')}
      </AntdCustomButton>
      <AntdCustomButton className="cancel-button mb-[12px]" onClick={onCancel}>
        {t('Cancel')}
      </AntdCustomButton>
      <BodyText>
        {t('After saving, the preview editor will reload. This will take a few minutes.')}
      </BodyText>
    </div>
  );
};

export default ActionButtons;
